// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"215":"46409cb2","785":"3e0cbfb7","807":"46409cb2"}[chunkId] + ".chunk.css";
};